import {
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import { map } from 'jquery';
import { envAwarePost } from '../util/util'

export const readSteps = createAsyncThunk(
	"readSteps",
	async (payload) => envAwarePost("api/wearables/api.php", {action:"readSteps",...payload})
);

export const readData = createAsyncThunk(
	"readData",
	async (payload) => envAwarePost("api/wearables/api.php", {action:"readData",...payload})
);

const wearableSlice = createSlice({
	name: 'wearableSlice',
	initialState: {
		steps : [],
        heartRate : [],
        caloriesBurned : [],
        weight: [],
        bodyFat: [],
        loading: false,
        measurementSystem: ""
	},
	reducers: {
		
	},
	extraReducers: {
		[readSteps.fulfilled]: (state, action) => {
            state.steps = action.payload.data;
		},	
        [readSteps.pending] : (state, action) =>{
            state.loading = true;
        },
        [readData.pending] : (state, action) =>{
            state.loading = true;
        },
        [readData.fulfilled]: (state, action) => {
            state.loading = false;

            state.measurementSystem = action?.payload?.measurement_system;
            
            let dataType = action?.payload?.type
            if (dataType == "heart_rate") {
                state.heartRate = action.payload.data;
            } else if (dataType == "calories") {
                state.calories = action.payload.data;
            } else if (dataType == "weight") {
                state.weight = action.payload.data;
            } else if (dataType == "body_fat") {
                state.bodyFat = action.payload.data;
            }
		},
	}
})

export const {  } = wearableSlice.actions

export default wearableSlice.reducer